import { makePost, makePut, makeGet } from './ServiceManager';

export const updateUserPreferences = async (user) => {
  const result = await makePut('service/user/preferences', { user });
  return result;
};

export const insertUserPreferences = async (user) => {
  const result = await makePost('service/user/preferences', { user });
  return result;
};

export const getUserPreferences = async (email) => {
  const result = await makeGet(`service/user/preferences/${email}`);
  return result;
};



// WEBPACK FOOTER //
// ./src/services/UserPreferencesManager.js